var MIN_SIGNING_FIELD_FONT_SIZE = 16;
var MAX_SIGNING_FIELD_FONT_SIZE = 32;
var MIN_MANUAL_FIELD_FONT_SIZE = 7;
var MAX_MANUAL_FIELD_FONT_SIZE = 32;
var MIN_TEXT_FIELD_AUTOSCALE_FONT_SIZE = 7;
var MAX_TEXT_FIELD_AUTOSCALE_FONT_SIZE = 13;
var MANUAL_TEXT_FIELD_LINE_HEIGHT = 1.25;

var calculatedMaxTextFieldFontSize = function calculatedMaxTextFieldFontSize(fieldHeight) {
  var size = fieldHeight / MANUAL_TEXT_FIELD_LINE_HEIGHT; // The calculated size is reduced by 0.5px to ensure the field scroll height
  // is not affected when using the max font size.

  size -= 0.5;
  return Math.floor(size);
}; // Calculate font size for the field based on the bounding and content
// dimensions and the allowable min and max for the type of field.


var scaleFontSize = function scaleFontSize(bounding, content, maxSize, minSize) {
  if (!bounding || !content) {
    return undefined;
  }

  var boundingWidth = bounding.offsetWidth;
  var boundingHeight = bounding.offsetHeight;
  var contentWidth = content.offsetWidth;
  var contentHeight = content.offsetHeight;
  var currentFontSize = window.getComputedStyle(bounding, null).getPropertyValue('font-size');
  var maxCalculatedFontSize;

  if (contentWidth === 0) {
    // This sets default font size for empty manual text fields.
    maxCalculatedFontSize = calculatedMaxTextFieldFontSize(boundingHeight);
  } else {
    // Determine the max font size that will fit in the field based on the
    // fields bounding and content dimensions.
    var widthFontSize = parseFloat(currentFontSize) * boundingWidth / contentWidth;
    var heightFontSize = parseFloat(currentFontSize) * boundingHeight / contentHeight;
    maxCalculatedFontSize = Math.min(widthFontSize, heightFontSize);
  }

  var fontSize = Math.max(Math.min(maxCalculatedFontSize, maxSize), minSize);
  return fontSize ? Math.floor(fontSize) : undefined;
};

var scaleTextFont = function scaleTextFont(bounding, content) {
  return scaleFontSize(bounding, content, MAX_TEXT_FIELD_AUTOSCALE_FONT_SIZE, MIN_TEXT_FIELD_AUTOSCALE_FONT_SIZE);
};

var scaleSigningFont = function scaleSigningFont(bounding, content) {
  return scaleFontSize(bounding, content, MAX_SIGNING_FIELD_FONT_SIZE, MIN_SIGNING_FIELD_FONT_SIZE);
};

var fontSizeOptions = function fontSizeOptions(maxSize, minSize) {
  var options = [];

  for (var i = minSize; i <= maxSize; i += 1) {
    options.push({
      value: i,
      label: "".concat(i, "px")
    });
  }

  return options;
};

var textFontSizeOptions = function textFontSizeOptions(field) {
  var calculatedMaxSize = calculatedMaxTextFieldFontSize(field.height);
  var maxSize = Math.min(MAX_MANUAL_FIELD_FONT_SIZE, calculatedMaxSize);
  return fontSizeOptions(maxSize, MIN_MANUAL_FIELD_FONT_SIZE);
};

var signingFontSizeOptions = function signingFontSizeOptions(maxSize) {
  return fontSizeOptions(maxSize !== null && maxSize !== void 0 ? maxSize : MAX_SIGNING_FIELD_FONT_SIZE, MIN_SIGNING_FIELD_FONT_SIZE);
};

export { MANUAL_TEXT_FIELD_LINE_HEIGHT, MAX_MANUAL_FIELD_FONT_SIZE, MAX_SIGNING_FIELD_FONT_SIZE, MAX_TEXT_FIELD_AUTOSCALE_FONT_SIZE, MIN_MANUAL_FIELD_FONT_SIZE, MIN_SIGNING_FIELD_FONT_SIZE, MIN_TEXT_FIELD_AUTOSCALE_FONT_SIZE, scaleFontSize, scaleSigningFont, scaleTextFont, signingFontSizeOptions, textFontSizeOptions };